import Vue from "vue";
import VueI18n from "vue-i18n";
import locale from "element-ui/lib/locale";
//国际化
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: sessionStorage.getItem('defaultLang') == "en_US" ? "en_US" : "zh_CN", // 语言标识,默认中文
  messages: {
    zh_CN: require("@/assets/lang/zh_CN.js"), // 中文语言包
    en_US: require("@/assets/lang/en_US.js") // 英文语言包
  }
});
locale.i18n((key, value) => i18n.t(key, value)); //兼容element

export default i18n;



// WEBPACK FOOTER //
// ./src/api/i18n/index.js